import { useEffect } from 'react';

const setupDriftEventListener = () => {
  useEffect(() => {
    let timer = 0;

    const interval = setInterval(() => {
      if (typeof window !== 'undefined' && window.drift) {
        if (window.innerWidth <= 768) {
          window.drift.on('ready', () => {
            window.drift.on('conversation:playbookDismissed', () => {
              window.drift.api.widget.hide();
            });
            window.drift.on('chatClose', () => {
              window.drift.api.widget.hide();
            });
            window.drift.on('sliderMessage:close', () => {
              window.drift.api.widget.hide();
            });
          });
        }
        clearInterval(interval);
      } else if (timer >= 60) {
        clearInterval(interval);
      }
      timer += 1;
    }, 500);

    return () => clearInterval(interval);
  }, []);
};

export default setupDriftEventListener;
